import {SearchService} from "../../services/search.service";
import {currencyList} from "./constants";

export class Currencies {

    public readonly default = 'USD';
    public readonly list = currencyList;

    public readonly signs: any = {
        USD: '$',
        EUR: '€',
        INR: '₹',
        MYR: 'RM',
        THB: '฿',
        JPY: '¥',
        GBP: '£',
        AUD: 'A$',
        CAD: 'CA$',
        NZD: 'NZ$',
        SGD: 'S$'
    };

    private searchService: SearchService;
    private exchangeRates: any = {};
    private selectedCurrency: string = 'USD';
    private sign: string = '$';

    public toggle = false;


    constructor(searchService: SearchService) {
        this.searchService = searchService;
    }

    public getCurrency() {
        this.searchService.getCurrency()
            .then((res: any) => {
                this.exchangeRates = res.data;
            })
    }

    public getExchangeRate() {
        return this.exchangeRates['USD' + this.selectedCurrency];
    }

    public setCurrent(currency: string) {
        this.selectedCurrency = currency;
        this.sign = this.getSign();
    }

    public getCurrent() {
        return this.selectedCurrency;
    }

    public getSign(currency?: string) {
        const c = currency ? currency : this.selectedCurrency;
        return this.signs[c];
    }

    public toCurrent(usdValue: number) {
        return (usdValue * this.getExchangeRate()).toFixed();
    }

    public commitToStore(store: any, key: string) {
        store.commit(key, {
            code: this.selectedCurrency,
            sign: this.sign,
            rate: this.getExchangeRate()
        });
    }

}
